import { render, staticRenderFns } from "./BestVideoDynamicMarquee.vue?vue&type=template&id=dfca86ba&scoped=true&"
import script from "./BestVideoDynamicMarquee.vue?vue&type=script&lang=js&"
export * from "./BestVideoDynamicMarquee.vue?vue&type=script&lang=js&"
import style0 from "./BestVideoDynamicMarquee.vue?vue&type=style&index=0&id=dfca86ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfca86ba",
  null
  
)

export default component.exports